<template>
  <section class="c4-padwrap" :aria-label="tx('id.keypad')">
    <div class="c4-pad">
      <button v-for="n in 9" :key="n" type="button" :data-fk="'k' + n" @click="$emit('key', String(n))">{{ n }}</button>
      <button type="button" data-fk="kb" aria-label="Backspace" @click="$emit('back')">
        <i class="mdi mdi-backspace-outline" aria-hidden="true"></i>
      </button>
      <button type="button" data-fk="k0" @click="$emit('key', '0')">0</button>
      <button type="button" class="ok" data-fk="kok" :disabled="!canSubmit" :aria-label="tx('id.submit')" @click="$emit('submit')">
        <i class="mdi mdi-check-bold" aria-hidden="true"></i>
      </button>
    </div>
  </section>
</template>

<script>
import canteenV4Text from "@/mixins/canteenV4Text";

export default {
  name: "CanteenKeypad",
  mixins: [canteenV4Text],
  props: {
    canSubmit: { type: Boolean, default: false },
  },
};
</script>
